<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>{{ state == 'archived' ? '已归档售后工单' : '售后工单' }}</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入姓名/手机/编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          @click="doNew"
          class="c-m-l-10"
          v-has="'AfterSaleServiceAppointments?colName=workflowAlert,add'"
        >
          新建售后工单
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'regex:exts.nameAfterSaleSA|string#or': searchValue,
                'regex:exts.phoneAfterSaleSA|string#or': searchValue,
                'is:type1Type|integer#and': 1,
                'is:exts.orgIdAfterSaleSA|string#and': orgId,
                'in:state|array-integer#and': state == 'archived' ? '-1' : '0,1,2,3', //合同状态
                'regex:exts.orderNumSA|string#or': searchValue,
                beanName: 'workflowAlert',
                title: '售后工单'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh && extFields.length"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields">
            <template slot="nameAfterSaleSA">
              <el-table-column
                label="客户姓名"
                width="90"
                fixed
                show-overflow-tooltip
                prop="nameAfterSaleSA"
              >
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="
                      $router.push({
                        path: `/AfterSaleServiceAppointment/${scope.row._id}?colName=${colName}`
                      })
                    "
                    type="text"
                  >
                    {{ scope.row.exts.nameAfterSaleSA }}
                  </el-button>
                </template>
              </el-table-column>
            </template>
            <template slot="phoneAfterSaleSA">
              <el-table-column prop="exts.phoneAfterSaleSA" label="客户电话" width="120px">
                <template slot-scope="scope">
                  <div v-if="scope.row.exts.phoneAfterSaleSA">
                    {{ scope.row.exts.phoneAfterSaleSA }}
                  </div>
                  <template v-else>
                    <el-popover
                      placement="top-start"
                      trigger="click"
                      :content="privateNumber.phone"
                    >
                      <el-button
                        slot="reference"
                        size="mini"
                        @click="osg.getPrivateNumber('9', null, scope.row._id, scope.row.exts.sid)"
                      >
                        查看中间号
                      </el-button>
                    </el-popover>
                  </template>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <!-- <el-table-column fixed="right" width="100" label="操作" v-if="false">
            <template slot-scope="scope">
              <template>
                <el-button @click.native.prevent="doRemove(scope.row)" size="mini">
                  删除
                </el-button>
              </template>
            </template>
          </el-table-column> -->
          <el-table-column
            fixed="right"
            width="100px"
            v-if="osg.has('AfterSaleServiceAppointments?colName=workflowAlert,archive')"
          >
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="state != 'archived'">
                    <el-dropdown-item
                      v-if="osg.has('AfterSaleServiceAppointments?colName=workflowAlert,archive')"
                      @click.native.prevent="doArchive(scope.row, '归档')"
                    >
                      归档
                    </el-dropdown-item>
                  </template>
                  <template v-else>
                    <el-dropdown-item
                      v-if="
                        osg.has(
                          'AfterSaleServiceAppointments?colName=workflowAlert&state=archived,recover'
                        )
                      "
                      @click.native.prevent="doArchive(scope.row, '恢复')"
                    >
                      恢复
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else height="calc(100% - 50px)" :data="fpi.data"></el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="新增售后工单"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        :upload="upload"
        ref="form"
        @changeForm="osg.changeForm"
      >
        <template slot="phoneAfterSaleSA">
          <el-input
            v-model="formData.exts.phoneAfterSaleSA"
            @blur="SAafterSalePhone"
            @input="
              formData.exts.sid = '';
              options['relatedPerson'] = [];
              formData.exts.relatedPerson = [];
            "
          ></el-input>
        </template>
        <template slot="sid">
          <el-select
            v-model="formData.exts.sid"
            placeholder="请选择工单"
            clearable
            @change="sidChange()"
          >
            <el-option
              style="width:900px"
              v-for="item in options['sid']"
              :key="item._id"
              :label="item.title"
              :value="item._id"
            >
              <template>
                <p class="c-flex c-flex-between">
                  <span class="c-m-r-10" v-if="item.title">标题：{{ item.title }}</span>
                  <span class="c-m-r-10" v-if="item.title">姓名：{{ item.name }}</span>
                  <span class="c-m-r-10" v-if="item.title">手机号：{{ item.phone }}</span>
                  <span class="c-m-r-10" v-if="item.orderNum">编号：{{ item.orderNum }}</span>
                  <span class="c-m-r-10" v-if="item.status">
                    状态：{{ osg.codelabel('status', item.status) }}
                  </span>
                </p>
              </template>
            </el-option>
          </el-select>
        </template>
        <template slot="relatedPerson">
          <el-select
            ref="selectRelatedPerson"
            v-model="formData.exts.relatedPerson"
            placeholder="请选择关联人"
            clearable
            multiple
            @change="
              () => {
                if ($refs['selectRelatedPerson'] && $refs['selectRelatedPerson'][0]) {
                  $refs['selectRelatedPerson'][0].visible = false; //监听值发生变化就关闭它
                } else if ($refs['selectRelatedPerson']) {
                  $refs['selectRelatedPerson'].visible = false;
                }
                $forceUpdate();
              }
            "
          >
            <el-option
              v-for="item in options['relatedPerson']"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            >
              <template>
                <p class="c-flex c-flex-between">
                  <span class="c-m-r-10">{{ item.name }}</span>
                  <span>{{ item.roleName }}</span>
                </p>
              </template>
            </el-option>
          </el-select>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'workflowAlert',
  props: {},
  data() {
    return {
      name: 'workflowAlert',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        exts: {
          sid: '',
          relatedPerson: []
        }
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_status: { codeId: 'STATUS' },
        sid: []
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      colName: '', //动态表名
      orgId: '', //从地址拿过滤组织的id
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      refresh: true, //表格刷新
      //中间号
      privateNumber: {
        show: false,
        phone: ''
      },
      state: null //状态 archived归档
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  created() {
    this.state = this.$route.query.state;
  },
  async mounted() {
    this.doInit();
    this.osg.getFields(this.colName, () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatProvince(row, column, cellValue) {
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(row, column, cellValue) {
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(row, column, cellValue) {
      return this.osg.areaObj.county_list[cellValue];
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: { sid: '', relatedPerson: [] } };
      this.colName = this.osg.paramObj().colName; //从地址栏获取动态表名
      this.orgId = this.osg.paramObj().orgId; //从地址栏获取orgId
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows || 50,
        'regex:exts.nameAfterSaleSA|string#or': this.searchValue,
        'regex:exts.phoneAfterSaleSA|string#or': this.searchValue,
        'regex:exts.orderNumSA|string#or': this.searchValue,
        'is:type1Type|integer#and': 1,
        'is:exts.orgIdAfterSaleSA|string#and': this.orgId,
        'in:state|array-integer#and': this.state == 'archived' ? '-1' : '0,1,2,3', //合同状态
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/workflowAlert/query.do', params, res => {
        this.refresh = false;
        this.fpi = res;
        this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          console.log(this.extFields);
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      var row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    //根据输入的手机号请求工单
    SAafterSalePhone() {
      console.log(this.formData);
      if (this.formData.exts.phoneAfterSaleSA) {
        this.osg.ajax(
          'basic/serviceAppointment/query.do',
          {
            'regex:phone|string#and': this.formData.exts.phoneAfterSaleSA
          },
          res => {
            this.$set(this.options, 'sid', res.data);
          }
        );
      } else {
        this.$set(this.options, 'sid', []);
      }
    },
    //切换工单
    sidChange() {
      this.$set(this.formData.exts, 'sid', this.formData.exts.sid);
      if (this.formData.exts.sid) {
        let codeArr = Array.isArray(this.formData.exts.afterSaleType)
          ? this.formData.exts.afterSaleType.flat()
          : [];
        let code = codeArr.indexOf('40410') != -1 ? '40410' : codeArr.join(',');
        console.log(code);
        this.osg.ajax(
          'biz/workflowAlert/queryAboutHandleUsers.do',
          {
            sid: this.formData.exts.sid,
            code
          },
          res => {
            this.$set(this.options, 'relatedPerson', res.data);
            this.formData.exts.relatedPerson = '';
            this.$forceUpdate();
          },
          {
            fail: () => {
              this.$set(this.options, 'relatedPerson', []);
              this.formData.exts.relatedPerson = '';
            }
          }
        );
      } else {
        this.$set(this.options, 'relatedPerson', []);
        this.formData.exts.relatedPerson = '';
      }
      this.$forceUpdate();
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        let extsData = this.$util.deepCopy(this.formData.exts);
        // //TODO:写死
        extsData.relatedPerson = Array.isArray(extsData.relatedPerson)
          ? extsData.relatedPerson.join(',')
          : '';
        //将选择的关联人冗余存储中文
        let handleData = [];
        this.options['relatedPerson'].forEach(item => {
          if (this.formData.exts.relatedPerson.indexOf(item._id) != -1) {
            handleData.push(item.name);
          }
        });
        if (handleData && handleData.length) extsData.handleUserNames = handleData.join('、');
        //拿到选中的工单对象
        let activeSA = this.options['sid'].filter(item => item._id == extsData.sid)[0];
        if (activeSA && activeSA.exts) {
          extsData.sTerritory = activeSA.exts.sTerritory; //工单片区
          extsData.orderNumSA = activeSA.orderNum; //工单编号
          extsData.leakagesite = activeSA.exts.leakagesite; //工单维修部位
          extsData.orgIdAfterSaleSA = activeSA.orgId; //工单服务商Id
          extsData.orgNameAfterSaleSA = activeSA.orgName; //工单服务商名称
          extsData.createTimeSA = activeSA.createTime; //工单创建时间
        }
        let params = {
          handlerIds: this.formData.exts.relatedPerson,
          type: '1',
          type1Type: '1',
          memo: this.formData.exts.describe,
          exts: extsData
        };
        params.orgId = activeSA.orgId; //工单服务商Id
        console.log(params);
        // return;
        this.osg.ajax('biz/workflowAlert/addPostSalesService.do', params, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //归档、恢复
    doArchive(params) {
      let row = this.$util.deepCopy(params);
      var msg = '';
      if (row.state != -1) {
        msg = '归档';
        row.state = -1;
      } else {
        msg = '恢复';
        row.state = 1;
      }
      this.osg.confirm(`是否确认${msg} ${row.exts.orderNumSA || ''}吗？`, () => {
        this.osg.ajax('/biz/workflowAlert/upsert.do', row, res => {
          this.doInit();
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    //删除，手动把state修改为-1
    doRemove(obj) {
      if (obj && obj.state == 1) {
        this.osg.confirm('确定要删除吗？', () => {
          obj.state = -1;
          this.osg.ajax('biz/workflowAlert/addPostSalesService.do', obj, res => {
            this.doInit();
            this.getData();
            this.osg.toast('删除成功！');
          });
        });
      } else {
        this.osg.toast('状态有误，请联系管理员！', 'error');
      }
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      this.state = this.$route.query.state;
      // this.searchValue = ''; //切换页面清空过滤
      // this.osg.getFpi();
      // this.getData();
      //将过滤条件都删除
      window.sessionStorage.removeItem('filter');
      this.viewReload();
    }
  }
};
</script>
